// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__UFdd1","wrap_violet":"style_wrap_violet__e7aa7","amount":"style_amount__dDoVs"};